import Button from 'components/Button.jsx';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'hooks/useTheme';
import OpenDoorAnimated from 'Icons/OpenDoor.jsx';

const ImageCard = ({
  imageSrc,
  titleItalic,
  titleGrotesk,
  description,
  className = '',
  imageHeight,
  imageWidth,
  cardWidth,
  showVector = false,
  buttonText,
  buttonLink,
  imageUrl,
  buttonVariant = 'dark',
  imgClassName = '',
  link,
  linkLabel,
}) => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`flex flex-column full-width image-card full-height ${className}`}
      style={{ ...(cardWidth && { width: cardWidth }) }}
    >
      <img
        src={imageUrl || imageSrc}
        alt={titleItalic || titleGrotesk}
        className={`full-width ${imgClassName}`}
        style={{
          ...(imageHeight && { height: imageHeight }),
          ...(imageWidth && { width: imageWidth }),
        }}
      />
      <div
        className={`image-card-content ${
          isDarkMode ? '' : 'dark-menu-section'
        }`}
      >
        <div>
          <div className='row-gap-16 flex flex-column'>
            {showVector && <span className='full-width vector' />}
            <p className='title font-secondary'>
              {titleItalic} <span className='font-primary'>{titleGrotesk}</span>
            </p>
          </div>
        </div>
        {description && <div className='description-text'>{description}</div>}
        {link && (
          <a
            href={link}
            target='_blank'
            rel='noopener noreferrer'
            className='team-member-link'
          >
            {linkLabel}
            <OpenDoorAnimated
              color={isDarkMode ? '#ffffff' : 'rgba(21, 41, 48, 1)'}
              verticalAlign='center'
            />
          </a>
        )}
        {buttonText && buttonLink && (
          <Button
            variant={buttonVariant}
            showIcon={true}
            onClick={() => navigate(buttonLink)}
          >
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ImageCard;
